<template>
  <Modal
    v-model="modalShow"
    title="手机号验证"
    :width="360"
    :mask-closable="false"
  >
    <div>
      <div class="flex items-center gap-2 mb-4">
        <Input v-model="phoneNo" :maxlength="11" placeholder="请输入手机号" style="width: 228px" />
        <div v-if="seconds > 0" class="whitespace-nowrap">{{ seconds }}s后再次获取</div>
        <Button v-else @click="handleGetVerifyCode">获取验证码</Button>
      </div>
      <Input v-model="verifyCode" placeholder="请输入验证码" />
    </div>
    <template #footer>
      <Button @click="handleClose">取消</Button>
      <Button type="primary" @click="handleConfirm">确定</Button>
    </template>
  </Modal>
</template>

<script lang="js">
import { Modal, Input, Button } from 'iview'
import { commons } from '@/apiconfig';
import ajax from '@/utils/ajaxUtil';

let timer
const COUNTDOWN_TIME = 60

export default {
  name: 'PhoneVerify',
  components: {
    Modal,
    Input,
    Button
  },
  data() {
    return {
      modalShow: true,
      phoneNo: '',
      verifyCode: '',
      hasGetCode: false,
      seconds: 0,
    };
  },
  beforeDestroy() {
    clearInterval(timer);
  },
  methods: {
    async handleGetVerifyCode() {
      await ajax.post({
        url: commons.getVerificationCode,
        params: {
          phoneNo: this.phoneNo,
          type: 'DX_GET_FILE_UPLOAD_INFO'
        }
      })
      this.$message.success('已发送手机验证码');
      this.hasGetCode = true;
      this.seconds = COUNTDOWN_TIME;
      clearInterval(timer);
      timer = setInterval(() => {
        this.seconds -= 1;
        if (this.seconds <= 0) {
          clearInterval(timer);
          this.seconds = 0;
        }
      }, 1000);
    },
    handleClose() {
      this.$emit('close');
    },
    handleConfirm() {
      if (!this.phoneNo) {
        this.$message.error('请填写手机号');
        return;
      }
      if (!this.hasGetCode) {
        this.$message.error('请获取验证码');
        return;
      }
      if (!this.verifyCode) {
        this.$message.error('请填写验证码');
      }
      this.$emit('confirm', {
        phoneNo: this.phoneNo,
        verifyCode: this.verifyCode
      });
    }
  }

}
</script>